<div class="global-message-component">
    <mat-spinner *ngIf="data.spinner" diameter="22"></mat-spinner>
    <span class="global-message-component__message">{{ data.message }}</span>
</div>
